// libraries
import { PhoneInput as InterstatePhoneInput } from '@interstate/components/PhoneInput';
import { withSelectOnFocus } from '../selectOnFocus/withSelectOnFocus';

/**
 * Thin pass-through wrapper over Interstate's PhoneInput that adds select-all
 * on focus (so a mouse click highlights the value the same way Tab does).
 * Toggle off => identical to the raw PhoneInput.
 */
export const PhoneInput = withSelectOnFocus(InterstatePhoneInput);

PhoneInput.displayName = 'PhoneInput';
